module.exports = __webpack_public_path__ + "static/commonwealth-9be2dab17a6cd7759b4879a3e8b2d930.png";